module.exports = __webpack_public_path__ + "static/media/warehouse2.9160b786.webp";